// extracted by mini-css-extract-plugin
export var menuIcon = "_q2-0";
export var menuIconInline = "_q2-1";